var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.88458 10.2849V14.4008C2.88458 18.5166 4.60958 20.1666 8.91249 20.1666H14.0779C18.3808 20.1666 20.1058 18.5166 20.1058 14.4008V10.2849M11.5 10.9999C13.2537 10.9999 14.5475 9.63409 14.375 7.95659L13.7425 1.83325H9.26708L8.62499 7.95659C8.45249 9.63409 9.74624 10.9999 11.5 10.9999ZM17.5471 10.9999C19.4829 10.9999 20.9012 9.49659 20.7096 7.65409L20.4412 5.13325C20.0962 2.74992 19.1379 1.83325 16.6271 1.83325H13.7042L14.375 8.25909C14.5379 9.77159 15.9658 10.9999 17.5471 10.9999ZM5.40499 10.9999C6.98624 10.9999 8.41416 9.77159 8.56749 8.25909L9.23833 1.83325H6.31541C3.80458 1.83325 2.84624 2.74992 2.50124 5.13325L2.24249 7.65409C2.05083 9.49659 3.46916 10.9999 5.40499 10.9999ZM11.5 15.5833C9.89958 15.5833 9.10416 16.3441 9.10416 17.8749V20.1666H13.8958V17.8749C13.8958 16.3441 13.1004 15.5833 11.5 15.5833Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.146071bd4e297364cd8156d14a3d870c.svg";
export { ForwardRef as ReactComponent };